import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

//Fetch description or page data
async function markAsReadNotification(id) {
	try {
		const token = localStorage.getItem("token");
		const response = await axiosInstance.post(
			`${apiUrl}/notifications/${id}/read`,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		console.error("Error in mark as read:", error);
		throw new Error(
			error.response
				? error.response.data.message
				: "An unexpected error occurred"
		);
	}
}

export { markAsReadNotification };
